import { useEffect } from 'react';

/**
 * Custom hook to manage document title
 * @param {string} title - The title to set
 * @param {string} defaultTitle - The default title to restore on unmount (optional)
 */
export const useDocumentTitle = (title, defaultTitle = 'RealSoft Newsletter') => {
  useEffect(() => {
    // Set the title
    document.title = title;
    
    // Cleanup function to restore default title
    return () => {
      document.title = defaultTitle;
    };
  }, [title, defaultTitle]);
}; 